<template lang="pug">
  div
    div.label.basic600--text.text-uppercase {{ $t('date') }}
    div.d-flex.align-center.mt-2
      div(style="margin-bottom: -6px" @click="dateOrder = 'created'")
        eva-icon(:name="dateOrder === 'created' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'created' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
      div.ml-2.p2.primary--text(@click="dateOrder = 'created'") {{ $t('order_created') }}
    div.d-flex.align-center.mt-2
      div(style="margin-bottom: -6px" @click="dateOrder = 'scheduled'")
        eva-icon(:name="dateOrder === 'scheduled' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'scheduled' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
      div.ml-2.p2.primary--text(@click="dateOrder = 'scheduled'") {{ $t('order_scheduled') }}
    div.d-flex.align-center.mt-2(v-if="orderType === 'shipping'")
      div(style="margin-bottom: -6px" @click="dateOrder = 'shipped'")
        eva-icon(:name="dateOrder === 'shipped' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'shipped' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
      div.ml-2.p2.primary--text(@click="dateOrder = 'shipped'") {{ $t('order_shipped') }}
    div.d-flex.align-center.mt-2(v-if="orderType === 'completed'")
      div(style="margin-bottom: -6px" @click="dateOrder = 'received'")
        eva-icon(:name="dateOrder === 'received' ? 'radio-button-on' : 'radio-button-off'" :fill="dateOrder === 'received' ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic600" height="20" width="20" )
      div.ml-2.p2.primary--text(@click="dateOrder = 'received'") {{ $t('order_delivered') }}
    template(v-if="dateOrder")
      v-divider.basic300.my-3
      v-row(no-gutters)
        v-col.pb-2.pr-2.shrink(v-for="(range, i) in ranges" :key="i")
          v-chip.button-AA-tiny.text-uppercase.px-3(:key="range.value" label small :outlined="rangeOrder.value === range.value" :color="rangeOrder.value === range.value ? 'info500' : 'basic300'" :style="rangeOrder.value === range.value ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="selectRangeOrder(range)") {{ range.name }}
    div.c1.primary--text.mt-2(v-if="rangeOrder.dates && rangeOrder.dates.length > 0") {{ $t('date_range') }}:
      span.ml-1.info500--text {{ rangeOrder.dates[0] | displayDate }} - {{ rangeOrder.dates[1] | displayDate }}

    .modal
      date-picker-order(v-if="datePickerOrderDialog" :open.sync="datePickerOrderDialog" @selected="dateRangeSelected($event)" @cancel="selectAll")
</template>

<script>
import DatePickerOrder from '@/components/dialogs/order/DatePickerOrder.vue'

export default {
  name: 'DateOrder',
  components: { DatePickerOrder },
  props: ['parentDateOrder', 'parentRangeOrder', 'orderType'],
  data: vm => ({
    datePickerOrderDialog: false,
    ranges: [
      { name: vm.$t('all'), value: null, dates: null },
      { name: vm.$t('today'), value: 'today', dates: null },
      { name: vm.$t('yesterday'), value: 'yesterday', dates: null },
      { name: vm.$t('past_7_days'), value: 'week', dates: null },
      { name: vm.$t('this_month'), value: 'month', dates: null },
      { name: vm.$t('this_year'), value: 'year', dates: null },
      { name: vm.$t('custom_dates'), value: 'custom', dates: null }
    ]
  }),
  computed: {
    dateOrder: {
      get () {
        return this.parentDateOrder
      },
      set (newValue) {
        this.$emit('update:parentDateOrder', newValue)
      }
    },
    rangeOrder: {
      get () {
        return this.parentRangeOrder
      },
      set (newValue) {
        this.$emit('update:parentRangeOrder', newValue)
      }
    }
  },
  methods: {
    dateRangeSelected (dates) {
      this.$set(this.rangeOrder, 'dates', dates)
    },
    selectAll () {
      this.rangeOrder = { name: this.$t('all'), value: null, date: null }
    },
    selectRangeOrder (range) {
      if (range.value === 'custom') {
        this.rangeOrder = range
        this.$set(this.rangeOrder, 'dates', null)
        this.datePickerOrderDialog = true
      } else {
        this.rangeOrder = range
      }
    }
  }
}
</script>
